import React, { useEffect } from "react";
import MainContainer from "../components/containers/MainContainer";
import TopBar from "../components/containers/TopBar";
import BottomFloat2 from "../components/containers/BottomFloat2";

import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";

import { t2 } from "../Locale";
import CheckoutToggleOutput from "../components/CheckoutToggleOutput";
import { useState } from "react";

import Card4d from "../components/Card4d";
import FetchLogin from "../components/Fetch/FetchLogin";
import { compute4dTotal } from "../utils/functions";
import { setThankYou } from "../redux/items/ThankYou";
import { computeEmpty } from "../redux/items/FourDCompute";
import { setPersonalDetails } from "../redux/items/PersonalDetails";
import { setLoadingPage } from "../redux/items/PageLoading";

const LotteryBetSlip = () => {
  const language = useSelector((state) => state.Language);
  const personalDetails = useSelector((state) => state.personalDetails);

  const hist = useHistory();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.login.token);
  const bet = useSelector((state) => state.fourDCompute).reduce(
    (n, { placeBet }) => n.concat(placeBet),
    []
  );

  const fourDCompute = useSelector((state) => state.fourDCompute);
  const settings = useSelector((state) => state.drawSet.set);
  const user = useSelector((state) => state.login.user);

  const bottomRef = React.useRef(null);

  useEffect(() => {
    if (
      personalDetails?.name === "" ||
      personalDetails?.name === undefined ||
      personalDetails?.name === null
    )
      dispatch(
        setPersonalDetails({
          name: user.name,
          email: user.email,
        })
      );

    bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    // eslint-disable-next-line
  }, []);

  const [v, setV] = useState({
    loading: false,
    error: "",
  });

  const setV2 = (v2) => {
    setV((prev) => ({ ...prev, ...v2 }));
  };

  const reqCheckoutFourD = FetchLogin("four-d/checkout", {
    data: {
      token: token,
      bet: bet,
      name: personalDetails.name,
      email: personalDetails.email,
      web: document.location.origin,
    },
    callbackInit: () => {
      setV2({ error: "" });
      dispatch(setLoadingPage(true));
    },
    callback: (cb) => {
      if (!cb.response.success) {
        if (
          cb.response.message.indexOf(" must be a string") > -1 ||
          cb.response.message.indexOf(" field is required") > -1
        ) {
          dispatch(
            setPersonalDetails({
              name: user.name,
              email: user.email,
            })
          );
        }
        setV2({ error: cb.response.message });
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
      } else {
        dispatch(computeEmpty());
        dispatch(setThankYou(cb.response.data.all));
        hist.push("/thank-you");
      }
      dispatch(setLoadingPage(false));
    },
  });

  return (
    <MainContainer
      render={
        <Grid container direction="column">
          <TopBar
            leftSide="-1"
            title={t2("Lottery Bet Slip", language)}
            rightSide=""
          />
        </Grid>
      }
      style={{ height: 85 }}
      loading={v.loading}
    >
      <Card4d />

      <Typography
        variant="h3"
        style={{
          textAlign: "center",
          fontSize: 24,
          color: "#6D6D6D",
          marginTop: 20,
          fontWeight: "bold",
        }}
      >
        {t2("Personal Details", language)}
      </Typography>

      <Grid
        container
        style={{
          paddingLeft: 16,
          paddingRight: 16,
          marginTop: 10,
          marginBottom: 5,
        }}
      >
        <Grid item xs={12}>
          <div
            style={{
              fontSize: 18,
              width: "80%",
              margin: "0 auto",
              marginTop: 5,
            }}
          >
            <label>Name: </label>
            <b>{personalDetails.name}</b>
            <br />
            <label>Email: </label>
            <b>{personalDetails.email}</b>
            <br />
          </div>
        </Grid>
      </Grid>

      <CheckoutToggleOutput
        tab="credit-balance"
        conditionTab="credit-balance"
        title={<span>Credit Balance</span>}
        result={
          <Typography
            variant="body1"
            style={{
              marginTop: 22,
              marginBottom: -24,
              textAlign: "center",
            }}
          >
            If you would like Top-up your account,
            <br />
            Simply click on the Yellow Bar and follow the steps accordingly
          </Typography>
        }
      />

      <Typography
        dangerouslySetInnerHTML={{ __html: v.error }}
        style={{
          color: "red",
          textAlign: "center",
          paddingTop: 20,
          paddingBottom: 20,
        }}
      />
      <div ref={bottomRef} />
      <BottomFloat2
        total={compute4dTotal(fourDCompute, settings)}
        title="Place Bet"
        onClick={() => reqCheckoutFourD.handleTrigger()}
      />
    </MainContainer>
  );
};

export default LotteryBetSlip;
